import { render, staticRenderFns } from "./ContabilitaFatturazioneView.vue?vue&type=template&id=b673992a"
import script from "./ContabilitaFatturazioneView.vue?vue&type=script&lang=js"
export * from "./ContabilitaFatturazioneView.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaFatturazioneView.vue?vue&type=style&index=0&id=b673992a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports